export default [{
  path: '/grupo-empresarial',
  component: {
    resource: 'gruposempresariais',
    action: 'read',
    name: 'grupoEmpresarialBase',
    template: '<router-view />',
    meta: {
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'gruposempresariais',
    component: () => import('@/app-modulo/comuns/grupo-empresarial/GrupoEmpresarialView.vue'),
    meta: {
      resource: 'gruposempresariais',
      action: 'read',
      navActiveLink: 'gruposempresariais',
      pageTitle: 'Cadastro de grupos empresariais',
      breadcrumb: [
        {
          text: 'Grupos empresariais',
          to: { name: 'gruposempresariais' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-grupo-empresarial',
    component: () => import('@/app-modulo/comuns/grupo-empresarial/shared/components/cadastro/GrupoEmpresarial.vue'),
    meta: {
      resource: 'gruposempresariais',
      action: 'create',
      navActiveLink: 'gruposempresariais',
      pageTitle: 'Cadastro de grupos empresariais',
      breadcrumb: [
        {
          text: 'Grupos empresariais',
          to: { name: 'gruposempresariais' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-grupo-empresarial' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar/:id',
    name: 'editar-grupo-empresarial',
    component: () => import('@/app-modulo/comuns/grupo-empresarial/shared/components/cadastro/GrupoEmpresarial.vue'),
    meta: {
      resource: 'gruposempresariais',
      action: 'update',
      navActiveLink: 'gruposempresariais',
      pageTitle: 'Cadastro de grupos empresariais',
      breadcrumb: [
        {
          text: 'Grupos empresariais',
          to: { name: 'gruposempresariais' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-grupo-empresarial' },
          active: true,
        },
      ],
    },
  }],
}]
